module.exports = __webpack_public_path__ + "static/media/nrj.bc3e776e.png";